import { render, staticRenderFns } from "./groupSetting.vue?vue&type=template&id=e0d18512&"
import script from "./groupSetting.vue?vue&type=script&lang=js&"
export * from "./groupSetting.vue?vue&type=script&lang=js&"
import style0 from "./groupSetting.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports